import React from 'react';
import agLogo from 'assets/airgarage-logo.png';
import styles from './ToolIndicator.module.css';

const TOOL_LABELS: Record<string, string> = {
    get_revenue: 'Looking up revenue data',
    get_active_rentals: 'Checking active rentals',
    get_occupancy: 'Checking occupancy',
    get_reviews: 'Looking up reviews',
    get_events: 'Loading events',
    get_pricing: 'Checking pricing',
    get_peak_times: 'Analyzing peak times',
    get_promo_codes: 'Loading promo codes',
    get_visitors: 'Loading visitor list',
    get_tickets: 'Looking up tickets',
    get_team_members: 'Loading team members',
    create_event: 'Creating event',
    add_visitor: 'Adding visitor',
    create_promo_code: 'Creating promo code',
    delete_event: 'Deleting event',
    remove_visitor: 'Removing visitor',
    waive_ticket: 'Waiving ticket',
    invite_team_member: 'Sending invitation',
};

interface ToolIndicatorProps {
    tools: string[];
}

const ToolIndicator: React.FC<ToolIndicatorProps> = ({ tools }) => {
    const label = TOOL_LABELS[tools[tools.length - 1]] || 'Working';

    return (
        <div className={styles.row}>
            <img src={agLogo} alt="AirGarage" className={styles.avatar} />
            <div className={styles.indicator}>
                <span className={styles.spinner} />
                <span className={styles.label}>{label}...</span>
            </div>
        </div>
    );
};

export default ToolIndicator;
